module.exports = __webpack_public_path__ + "static/tile_sups-534d76a2dd1f1af4fff6bac3a307de27.jpg";